/*
 * @Author: edvardchen
 * @Date: 2017-12-06 17:35:42
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-20 11:09:54
 */

// @flow
import _ from 'lodash';
import { type Dispatch, type GetState } from '../types';

import {
  localStorage,
  track,
  onVisibilityChange,
  getBusinessType,
  commentExpWhiteList,
  listenToScroll,
} from '../../utility';

declare var __CLIENT__: boolean;

const KEY_READ_DURATION = 'interactive_reading_time';
const INTERVAL = 1000; // 1s

function reportCache(grayConfig: Object) {
  const old = localStorage.getItem(KEY_READ_DURATION);
  if (!old || typeof old !== 'object') {
    return;
  }
  Object.keys(old).forEach((key) => {
    const item = old[key];
    if (typeof item !== 'object' || !item.duration) {
      return;
    }

    // 这里不能随便调整，大数据有用这份数据去累特征,只会处理type=articleComment的上报
    const ext = {
      startTime: item.startTime,
      duration: item.duration,
      leaveTime: (item.startTime || 0) + (item.duration * 1000 || 0),
      type: item.entry === 'article' ? 'articleComment' : '',
    };

    track({
      location: item.entry || 'article',
      object: 'interactive',
      action: 'like',
      id: item.id,
      ext: JSON.stringify(ext),
      ch: item.ch,
      grayConfig,
      whiteList: commentExpWhiteList(),
    });
  });
  localStorage && localStorage.setItem(KEY_READ_DURATION); // remove;
}

// 避免多个窗口打开同一篇文章，所以使用时间戳为 key
const startRecording = ({ startTime, id, ...rest }: { startTime: number, id: string }) =>
  setInterval(() => {
    const old = localStorage.getItem(KEY_READ_DURATION) || {};

    const key = startTime;
    const { duration = 0 } = old[key] || {};

    old[key] = {
      ...rest,
      id,
      startTime,
      duration: duration + INTERVAL / 1000,
    };
    localStorage && localStorage.setItem(KEY_READ_DURATION, old);
  }, INTERVAL);

let timer: *;

const clearTimer = () => {
  timer && clearInterval(timer);
  timer = null;
};

export const makeStopRecordInteractiveTime = () => {
  if (!__CLIENT__) {
    return;
  }
  // reportCache();
  clearTimer();
};

export const isRecording = () => !!timer;

export const doLastReport = (grayConfig: Object) => reportCache(grayConfig);

export const makeStartRecordInteractiveTime = (key?: number) => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    article: { docId = '' },
    location: { query: { ch } = {} },
    postInfo: { vid },
    grayConfig = {},
  } = getState();
  !key && reportCache(grayConfig);

  clearTimer();
  const startTime = key || Date.now();

  timer = startRecording({
    startTime,
    id: docId || vid || '',
    ch,
    entry: getBusinessType(),
  });
  onVisibilityChange((event, hidden) => {
    clearTimer(); // 向后兼容，不管怎样，先停止定时器
    if (!hidden) {
      timer = startRecording({
        startTime,
        id: docId || vid || '',
        ch,
      });
    }
  });

  return startTime;
};

export const doConsumptionReport = () => {
  track({
    location: getBusinessType(),
    object: 'consumption',
    action: 'consume',
  });
};
// 福利时长上报
const checkTimeTaskStatus = () => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve(false);
    }
    const reportDataToWelfareCenter = _.get(window, 'browser.usercenter.reportDataToWelfareCenter');
    if (!reportDataToWelfareCenter) {
      resolve(false);
    }
    reportDataToWelfareCenter(
      (ret) => {
        const info = _.get(ret, 'jsonData.WelfareTaskInfo');
        if (info) {
          const { taskAccept, taskType, taskEvolve, extraInfo = {} } = info || {};
          const isTask = taskAccept && taskType === 1 && taskEvolve === 1;
          if (isTask) {
            resolve({
              timer: Number(extraInfo.timer) || 30000,
            });
          } else {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      },
      {
        businessid: 100,
        jsonData: JSON.stringify({
          business: 100,
        }),
      },
    );
  });
};
// 当前是否滚动状态
let isScrolling = false;
let timing = 0; // 累计阅读时长
const t1 = 5000; // 5秒积累一次时长
let t2 = 30000; // 30秒上报一次
const key = 'NEWS_WELFALE_READ_TIMING';
let welfaleTimer = null;
let onceInit = false; // 是否初始化过一次
const isToast = false;
// 循环上报事件初始化
const reportInit = (guid, docId, reportDataToWelfareCenter) => {
  const toast = _.get(window, 'browser.app.toast');
  timing = Number(localStorage.getItem(key)) || 0;
  isToast && toast(`读取缓存时长为:${timing / 1000}秒`);
  welfaleTimer = setInterval(() => {
    console.log('timeUpLoop', isScrolling, timing);
    if (isScrolling) {
      timing += t1;
      isToast && toast(`计时累加成功,目前为${timing / 1000}秒`);
      localStorage.setItem(key, timing);
      isScrolling = false;
    } else {
      isToast && toast(`5秒内没滑动，停止计时累加,目前为${timing / 1000}秒`);
    }
    if (timing >= t2) {
      isToast && toast(`${timing / 1000}秒累计，开始上报`);
      report2Welfare();
    }
  }, t1);
  window.WINDOW_WELFALE_READ_TIMING_INTERVAL = welfaleTimer;
  onceInit = true;
  const report2Welfare = async () => {
    console.log('report2WelfareLoop', isScrolling, timing);
    reportDataToWelfareCenter(
      (ret) => {
        console.log('执行成功回调 ret==', ret);
        timing = 0;
        localStorage.setItem(key, timing);
        isToast && toast('上报成功！！！');
      },
      {
        businessid: 100,
        jsondata: JSON.stringify({
          business: 100,
          guid,
          type: 1,
          step: 30,
          contentId: docId,
          time: parseInt(new Date().getTime() / 1000, 10),
        }),
      },
    );
  };
};
// 上报福利阅读时长
export const reportWelfareTiming = async (guid, docId) => {
  const result = await checkTimeTaskStatus().catch(() => {});
  const toast = _.get(window, 'browser.app.toast');
  // toast(`时长任务查询结果:${result ? '任务开始' : '未领任务'}`);
  if (result) {
    isToast && toast(`时长任务上报周期:${result.timer}`);
    t2 = result.timer || t2;
    const reportDataToWelfareCenter = _.get(window, 'browser.usercenter.reportDataToWelfareCenter');
    reportInit(guid, docId, reportDataToWelfareCenter);
    listenToScroll(() => {
      if (!window.WINDOW_WELFALE_READ_TIMING_INTERVAL && onceInit) {
        // 压后台回来重新激活
        isToast && toast('重新激活');
        reportInit(guid, docId, reportDataToWelfareCenter);
      }
      console.log('reportWelfareTiming', isScrolling, timing);
      isScrolling = true;
    });
  } else {
    timing = 0;
    localStorage.setItem(key, timing);
  }
};
